import { render, staticRenderFns } from "./VrijhedenStart.vue?vue&type=template&id=6dc73338&"
import script from "./VrijhedenStart.vue?vue&type=script&lang=js&"
export * from "./VrijhedenStart.vue?vue&type=script&lang=js&"
import style0 from "./VrijhedenStart.vue?vue&type=style&index=0&id=6dc73338&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports